import fr from "./fr";
import en from "./en";
import es from "./es";
import it from "./it";

export const LANGUAGES = {
  fr: { label: "Français", flag: "🇫🇷", translations: fr },
  en: { label: "English", flag: "🇬🇧", translations: en },
  es: { label: "Español", flag: "🇪🇸", translations: es },
  it: { label: "Italiano", flag: "🇮🇹", translations: it },
};

export const LANGUAGE_CODES = Object.keys(LANGUAGES);

/**
 * Detects the best language from the browser.
 * Returns 'fr' if nothing matches.
 */
export function detectLanguage() {
  const stored = localStorage.getItem("sensoria_lang");
  if (stored && LANGUAGES[stored]) return stored;

  const browserLangs = navigator.languages || [navigator.language || "fr"];
  for (const lang of browserLangs) {
    const code = lang.split("-")[0].toLowerCase();
    if (LANGUAGES[code]) return code;
  }
  return "fr";
}

/**
 * Simple interpolation: replaces {key} in string with values.
 * t("Hello {name}", { name: "John" }) → "Hello John"
 */
export function interpolate(str, vars = {}) {
  if (!str) return "";
  return str.replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] !== undefined ? String(vars[key]) : `{${key}}`
  );
}
